"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var core_utilities_1 = require("@syl-editor/core-utilities");
var parse_1 = require("@syl-editor/core-utilities/dist/lib/libs/parse");
var tools_1 = require("../utils/tools");
var toolbar_1 = require("../modules/toolbar");
var typeset_1 = require("../utils/typeset");
var PLUGIN_NAME = 'letter_space';
var LetterSpace = /** @class */ (function (_super) {
    __extends(LetterSpace, _super);
    function LetterSpace(editor, props) {
        var _this = _super.call(this, editor, props) || this;
        _this.name = 'letter_space';
        _this.tagName = function () { return 'span'; };
        _this.attrs = {
            space: {
                default: ''
            }
        };
        _this.parseDOM = [
            {
                style: 'letter-spacing',
                defaultFontSize: 16,
                formatAttrs: function (v) { return v; },
                getAttrs: function (style) {
                    var space = parse_1.getPx(style, this.defaultFontSize);
                    if (!space)
                        return false;
                    return this.formatAttrs({
                        space: space
                    });
                }
            }
        ];
        _this.toDOM = function (node) {
            var space = node.attrs.space;
            var attrs = {};
            if (+space) {
                attrs.style = "letter-spacing: " + space + "px;";
            }
            return [_this.tagName(), attrs, 0];
        };
        props && _this.constructParseDOM(props);
        return _this;
    }
    LetterSpace.prototype.constructParseDOM = function (config) {
        if (!config || !config.allowedValues)
            return;
        var formatAttrs = typeset_1.getFormatAttrsByValue(config.allowedValues, 'space').formatAttrs;
        if (config.defaultFontSize) {
            this.parseDOM[0].defaultFontSize = config.defaultFontSize;
        }
        this.parseDOM[0].formatAttrs = formatAttrs;
    };
    return LetterSpace;
}(core_utilities_1.Inline));
exports.LetterSpace = LetterSpace;
var LetterSpaceController = /** @class */ (function (_super) {
    __extends(LetterSpaceController, _super);
    function LetterSpaceController(editor, store, props) {
        var _this = _super.call(this, editor, store, props) || this;
        _this.name = PLUGIN_NAME;
        _this.constructValue = function (props) {
            if (props.values) {
                _this.toolbar.value = typeset_1.formatMenuValues('space', props.values);
            }
        };
        _this.toolbar = {
            className: PLUGIN_NAME,
            tooltip: PLUGIN_NAME,
            type: toolbar_1.TOOL_TYPE.DROPDOWN,
            value: [
                {
                    attrs: false,
                    text: '0'
                },
                {
                    attrs: { space: 0.5 },
                    text: '0.5'
                },
                {
                    attrs: { space: 1 },
                    text: '1'
                },
                {
                    attrs: { space: 1.5 },
                    text: '1.5'
                }
            ]
        };
        _this.disable = function (editor) {
            return tools_1.checkMarkDisable(editor.view, PLUGIN_NAME);
        };
        _this.constructValue(props);
        return _this;
    }
    return LetterSpaceController;
}(core_utilities_1.SylController));
exports.LetterSpaceController = LetterSpaceController;
var LetterSpacePlugin = /** @class */ (function (_super) {
    __extends(LetterSpacePlugin, _super);
    function LetterSpacePlugin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = PLUGIN_NAME;
        _this.Schema = LetterSpace;
        _this.Controller = LetterSpaceController;
        return _this;
    }
    return LetterSpacePlugin;
}(core_utilities_1.SylPlugin));
exports.LetterSpacePlugin = LetterSpacePlugin;
//# sourceMappingURL=letter-space.js.map